<template>
  <div :class="cropperCls">
    <div class="cropper-tools-box" style="text-align: center">
      <vueCropper
        ref="cropper"
        :img="option.img"
        :outputSize="option.size"
        :outputType="option.outputType"
        :info="true"
        :full="option.full"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :original="option.original"
        :autoCrop="option.autoCrop"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        :centerBox="option.centerBox"
        :infoTrue="option.infoTrue"
        :fixedBox="option.fixedBox"
      ></vueCropper>
    </div>
    <el-button @click="finish">btn</el-button>
    <!-- <u-upload
      :accept="accept"
      listType="none"
      :files="files"
      @change="handleChange"
      :size="size"
      :imgWidth="imgWidth"
      :imgHeight="imgHeight"
      :disabled="disabled"
      @progress="onProgress"
    >
      <el-button
        :disabled="disabled"
        size="small"
        :type="value ? '' : 'primary'"
        >{{ value ? "重新上传" : "上传图片" }}</el-button
      >
    </u-upload>
    <p :class="`${prefix}-tips`">
      {{
        tipsText
          ? tipsText
          : `${
              limitPx ? "限制" : "建议"
            }${imgWidth}*${imgHeight}px，格式${accept}，大小不超过${size}M`
      }}
    </p>

    <div
      :class="[`${prefix}-review`, { [`${prefix}-loading`]: percent < 100 }]"
    >
      <div class="showLoading" v-html="showr"></div>
      <div :class="`${prefix}-loader-mask`" v-if="percent < 100">
        <el-progress
          type="circle"
          :percentage="Math.round(percent)"
        ></el-progress>
      </div>
    </div> -->
  </div>
</template>
<script>
const prefix = "w-upload-image-cropper";

export default {
  props: {
    value: String,
    tipsText: String,
    accept: {
      type: String,
      default: ".jpg,.jpeg,.png",
    },
    imgHeight: {
      type: Number,
      default: 600,
    },
    imgWidth: {
      type: Number,
      default: 1960,
    },
    size: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 限制像素大小
    limitPx: {
      type: Boolean,
    },
  },
  data() {
    return {
      prefix,
      percent: 100,
      option: {
        img: "http://zk-web-object.oss-cn-qingdao.aliyuncs.com/wxy/img/11.jpg", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [], //页面显示的数组
    };
  },
  created() {},
  computed: {
    showr() {
      if (!this.value) {
        return "";
      }
      return `<img src="${this.value}" />`;
    },
    cropperCls() {
      return [prefix];
    },
    files() {
      return this.value ? [{ url: this.value }] : [];
    },
  },
  methods: {
    handleChange(list) {
      if (list.length) {
        let img = list.splice(-1);

        this.$emit("input", img[0].url);
      }
    },
    onProgress(event) {
      this.percent = event.percent;
    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        var fileName = 'goods' + this.fileinfo.uid
        this.loading = true
       //上传阿里云服务器
        client().put(fileName, data).then(result => {
          this.dialogVisible = false
          this.picsList.push(result.url)
        }).catch(err => {
          console.log(err)
          this.loading = false
        })
      })
    }
  },
};
</script>

<style lang="scss" scoped>
$prefixCls: w-upload-image-cropper;
.#{$prefixCls} {
  &-review {
    margin-top: 10px;
    border-radius: 4px;
    position: relative;
    img {
      max-width: 400px;
      max-height: 300px;
    }
  }
  &-loading {
    width: 200px;
    height: 200px;
  }
  &-tips {
    color: #bbb;
  }
  &-loader-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000, $alpha: 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    .el-progress__text {
      color: white;
    }
  }
}
.showLoading img,
video {
  max-width: 320px;
  max-height: 640px;
}

.cropper-tools-box {
  width: 500px;
  height: 500px;
  border: 1px solid red;
}
</style>